module.exports = __webpack_public_path__ + "img/Hotmart-7-pt.24d92c61.png";